export default __webpack_public_path__ + "static/media/SnowRemoval.029c07d7.png";